import React, { useState } from "react";
import styled from "styled-components";
import { ReactComponent as SearchIcon } from "../../../assets/img/icons/search.svg";
import { ReactComponent as SearchCross } from "../../../assets/img/icons/SearchCross.svg";

const AutomationEmailSearch: React.FC<any> = (props) => {
  const { placeholder, handleSearch, reset } = props;
  const [searchValue, setSearchValue] = useState("");

  const cleanSearchField = () => {
    setSearchValue("");
    reset();
  };

  const handleOnChange = (value: any) => {
    setSearchValue(value);
    if (!value || value.length === 0) {
      cleanSearchField();
      reset();
      return;
    }
  };

  const formSubmit = (e: any) => {
    if (searchValue === "") {
      cleanSearchField();
      return;
    }
    handleSearch(searchValue.trim());
  };

  return (
    <>
      <Wrapper>
        <div className="search-wraper">
          <div className="search-bar">
            <span className="refresh-search" onClick={formSubmit}>
              <SearchIcon />
            </span>
            <input
              type="text"
              name="search"
              className="search-input"
              placeholder={placeholder}
              onChange={(e) => handleOnChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") formSubmit(e);
              }}
              value={searchValue}
              data-id="search-subject-sender"
            />
            {searchValue ? (
              <span onClick={() => cleanSearchField()} className="clear-search">
                <SearchCross />
              </span>
            ) : null}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

AutomationEmailSearch.defaultProps = {
  placeholder: "Search emails and campaigns",
  value: "",
};

export default AutomationEmailSearch;

const Wrapper = styled.div`
  width: 100%;
  .search-wraper {
    position: relative;
    width: 100%;
    .search-results {
      border-radius: 22px;
      position: absolute;
      top: -80px;
      left: 0;
      // display: none;
      float: left;
      width: 100%;
      border: 1px solid #dadada;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transition: 0.5s;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        z-index: 1;
        visibility: visible;
      }
      ul.results-list {
        background: #fff;
        padding: 30px 55px 10px 55px;
        margin: 0;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          float: left;
          width: 100%;
          display: block;
          cursor: pointer;
          transition: 0.5s;
        }
      }
      .relevant-theme,
      .relevant-company {
        border-top: 1px solid #dadada;
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .search-hint {
        background: #def6e6;
        padding: 18px 25px 36px 25px;
        border-radius: 22px 22px 0 0;
        float: left;
        width: 100%;
        svg {
          float: left;
          width: 35px;
          height: 39px;
        }
        ul {
          margin: 0;
          float: left;
          li {
            color: #09a43a;
            font-size: 14px;
            font-weight: 400;
            list-style: none;
            strong {
              font-weight: 700;
            }
          }
        }
      }
    }
    .search-bar {
      border-radius: 27px;
      background: #ffffff;
      border: 1px solid #dadada;
      display: block;
      float: left;
      width: 100%;
      overflow: hidden;
      position: relative;
      span.clear-search {
        float: right;
        margin-top: 5px;
        margin-right: 12px;
        transition: 0.5s;
        cursor: pointer;
        position: absolute;
        right: 0;
      }
      span.refresh-search {
        padding-right: 5px;
        border-right: 1px solid #dadada;
        margin: 4px 8px 7px 8px;
        float: left;
        cursor: pointer;
        svg path {
          fill: #424b50;
        }
      }
      .search-input {
        float: left;
        border: none;
        outline: none;
        width: calc(100% - 70px);
        display: block;
        color: #424b50;
        font-weight: 400;
        font-size: 14px;
        margin-top: 5px;
        font-family: "robotoregular";
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        &::-webkit-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &::-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-ms-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:hover,
        &:active,
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
`;
